// extracted by mini-css-extract-plugin
module.exports = {"inputLabels":"FinalSubmissionLevel_inputLabels__1Iwh-","alertLabels":"FinalSubmissionLevel_alertLabels__3wbTW"};